export const products = [
  {
    id: 'quantum-cloud',
    image: '/images/products/quantum-cloud.svg',
    doc: '/docs/quantum-cloud-spec.txt',
    zh: { title: '量子云平台', desc: '高性能、低延迟的下一代云计算服务。' },
    en: { title: 'Quantum Cloud Platform', desc: 'Next-gen cloud with high performance and ultra-low latency.' }
  },
  {
    id: 'neural-engine',
    image: '/images/products/neural-engine.svg',
    doc: '/docs/neural-engine-spec.txt',
    zh: { title: '神经网络引擎', desc: '为企业提供端到端的 AI 能力与推理优化。' },
    en: { title: 'Neural Network Engine', desc: 'End-to-end AI capabilities with inference optimization.' }
  },
  {
    id: 'edge-intelligence',
    image: '/images/products/edge-intelligence.svg',
    doc: '/docs/edge-intelligence-spec.txt',
    zh: { title: '边缘智能设备', desc: '在设备端实现实时分析与安全计算。' },
    en: { title: 'Edge Intelligence Devices', desc: 'On-device real-time analytics and secure computation.' }
  },
  // Extra examples to make the scroller feel richer
  {
    id: 'holo-interface',
    image: '/images/products/holo-interface.svg',
    doc: '/docs/holo-interface-spec.txt',
    zh: { title: '全息交互界面', desc: '沉浸式 3D 界面与自然手势识别。' },
    en: { title: 'Holographic Interface', desc: 'Immersive 3D UI with natural gesture recognition.' }
  },
  {
    id: 'secure-fabric',
    image: '/images/products/secure-fabric.svg',
    doc: '/docs/secure-fabric-spec.txt',
    zh: { title: '零信任安全织网', desc: '端到端零信任与动态访问控制。' },
    en: { title: 'Zero-Trust Secure Fabric', desc: 'End-to-end zero-trust with dynamic access control.' }
  }
]
